import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatInputModule, MatButtonModule, MatProgressSpinnerModule} from '@angular/material';
import { CreatePassRoutingModule } from './create-password.routing';
import { CreatePasswordComponent } from './create-password.component';
import { SharedModule } from '../../shared/shared.module';
@NgModule({
  declarations: [
    CreatePasswordComponent
  ],
  imports: [CreatePassRoutingModule, 
    SharedModule, ReactiveFormsModule, FormsModule, CommonModule, MatButtonModule
  ,MatProgressSpinnerModule
  ],
    
  providers: [],
  bootstrap: []
})
export class CreatePassModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/create-password/create-password.module.ts